import http from 'hub-http/clients/apiClient';
export const BASE_URL = 'knowledge-content/v2/knowledge-article';
export function publishArticle(articleId) {
  // This needs to use http.postWithResponse in order to work with makeStructuredContentPublishAction
  return http.postWithResponse(`${BASE_URL}/${articleId}/draft/push-live`);
}
export function fetchArticle(articleId) {
  return http.get(`${BASE_URL}/${articleId}/draft`);
}
export function fetchAllArticles() {
  return http.get(`knowledge-content/v2/knowledge-article`);
}
export function createArticleTranslation(articleValues) {
  return http.post(`${BASE_URL}/`, {
    data: {
      values: articleValues
    }
  });
}
export const createArticle = article => {
  return http.post(`knowledge-content/v2/knowledge-article`, {
    data: article
  });
};
export const deleteArticle = articleId => {
  return http.delete(`knowledge-content/v2/knowledge-article/${articleId}`);
};
export const unpublishArticle = articleId => {
  // This needs to use http.postWithResponse in order to work with makeStructuredContentPublishAction
  return http.postWithResponse(`${BASE_URL}/${articleId}/unpublish`);
};